<script lang="ts">
  import {diffState} from "$lib/stores/masterdataStore";
  import {applyDiff, deleteDiffNoSideEffects} from "$lib/services/MasterdataService";

  const {diffId, sourceSystem, originatingEnv, onApplied}: {
    diffId: string | undefined;
    sourceSystem: string | undefined;
    originatingEnv: string;
    onApplied?: () => void;
  } = $props();

  let isApplying = $state(false);

  async function handleClick(e: Event) {
    e.preventDefault();
    if (!diffId || !sourceSystem) return;
    isApplying = true;
    try {
      const success = await applyDiff(sourceSystem, diffId, originatingEnv);
      diffState.set('Applied');
      if (!success) {
        await deleteDiffNoSideEffects(sourceSystem, diffId, originatingEnv);
      }
      onApplied?.();
    } catch {
      await deleteDiffNoSideEffects(sourceSystem, diffId, originatingEnv);
    } finally {
      isApplying = false;
    }
  }
</script>

{#if diffId}
  <button
      type="button"
      class="btn btn-primary-dark ml-1"
      disabled={isApplying || !sourceSystem}
      onclick={handleClick}
      aria-label="Apply masterdata diff"
  >
    {#if isApplying}
      Applying…
    {:else}
      Apply
    {/if}
  </button>
{/if}
